var indexOf = [].indexOf;

angular.module('app', ['ngRoute', 'ngCookies', 'ngResource', 'ngSanitize', 'ngAnimate', 'app.controllers', 'app.resources', 'app.services', 'app.directives', 'app.filters', 'mwTable', 'slickCarousel', 'angular-loading-bar', 'checklist-model', 'ng.deviceDetector', 'infinite-scroll', 'pascalprecht.translate', 'ngMeta']).run(['$rootScope', '$route', '$routeParams', 'smoothScr', '$cookies', '$location', '$timeout', 'APICheckin', 'APIChats', 'APIEvent', 'UI', '$window', '$translate', 'APIFavorites', 'ngMeta'].append(function(root, $route, $routeParams, smoothScr, $cookies, $location, $timeout, APICheckin, APIChats, APIEvent, UI, $window, $translate, APIFavorites, ngMeta) {
  var activeTimer, closeHimself, closeTimer, loadChat, logged_in_stat, menuOffcanvas, menuOffcanvasEl, routeReload, setActiveTimer, setCloseTimer, toFixedHex;
  ngMeta.init();
  root.overlay = false;
  root.pageLoaded = false;
  root.settings = null;
  root.preview = false;
  root.sync_error_is = false;
  
  // first of all load default event settings

  APIEvent.get({
    _entry: 'eventdata'
  }, function(data) {
    root.settings = data;
    // get session data
    return root.$emit('proveSession');
  }, function(response) {
    return UI.notify(false, "Can't laod application settings");
  });
  
  // Provide loading state for templates and controllers

  root.loading = false;
  root.$on('cfpLoadingBar:started', function() {
    return root.loading = true;
  });
  root.$on('cfpLoadingBar:completed', function() {
    return root.loading = false;
  });
  
  // Modals

  root.activeAction = false;
  activeTimer = null;
  closeTimer = null;
  closeHimself = true;
  setCloseTimer = function(minutes = 5, trigger = '') {
    console.debug("71 - ", trigger);
    return closeTimer = $timeout(function() {
      root.logout();
      closeHimself = false;
      return root.inactiveModal.hide();
    }, 1000 * 60 * minutes); // 5 min
  };
  setActiveTimer = function(minutes = 30) {
    return activeTimer = $timeout(function() {
      if (document.fullscreenElement) {
        return root.activeAction = true;
      }
      return root.inactiveModal.show();
    }, 1000 * 60 * minutes); // 30 min
  };
  root.inactiveModalEl = document.getElementById('inactiveModal');
  if (root.inactiveModalEl != null) {
    root.inactiveModal = bootstrap.Modal.getOrCreateInstance(root.inactiveModalEl);
    root.inactiveModalEl.addEventListener('hide.bs.modal', function(event) {
      if (closeHimself) {
        root.$broadcast('sendCustomStat', null, 'timeout_close', 'User closed inactivity modal');
      }
      root.activeAction = true;
      return root.$applyAsync();
    });
    root.inactiveModalEl.addEventListener('show.bs.modal', function(event) {
      root.$broadcast('sendCustomStat', null, 'timeout', 'User notification about 30 min inactivity');
      if (!root.activeAction) {
        setCloseTimer(0.3, "show modal if activeAction = false");
      }
      return root.$applyAsync();
    });
  }
  root.$watch('activeAction', function(newObj, oldObj) {
    var ref, ref1;
    console.debug("103 - watch activeAction = ", newObj);
    if (newObj) {
      if (activeTimer != null) {
        $timeout.cancel(activeTimer);
      }
      if (closeTimer != null) {
        $timeout.cancel(closeTimer);
      }
      return root.activeAction = false;
    } else if ((root.session != null) && ((ref = root.user) != null ? ref.auth_ticket : void 0)) {
      if (!((ref1 = root.inactiveModalEl) != null ? ref1.classList.contains('show') : void 0)) {
        return setActiveTimer();
      }
    }
  }, true);
  root.iframeInteraction = false;
  $window.addEventListener('focus', function(event) {
    var ref;
    if (root.iframeInteraction) {
      // Ignore focus events from iframe interactions
      return root.iframeInteraction = false;
    }
    if ((ref = root.inactiveModalEl) != null ? ref.classList.contains('show') : void 0) {
      root.activeAction = false;
      if (closeTimer != null) {
        $timeout.cancel(closeTimer);
      }
      return setCloseTimer(0.3, "?window focus if activeAction = false");
    }
  });
  $window.addEventListener("blur", function(event) {
    var ref, ref1, ref2;
    if (((ref = document.activeElement) != null ? (ref1 = ref.tagName) != null ? ref1.toLowerCase() : void 0 : void 0) === 'iframe') {
      // Ignore blur events from iframe interactions
      return root.iframeInteraction = true;
    }
    root.iframeInteraction = false;
    if ((closeTimer != null) && ((ref2 = root.inactiveModalEl) != null ? ref2.classList.contains('show') : void 0)) {
      root.activeAction = false;
      return $timeout.cancel(closeTimer);
    }
  });
  
  // Menu and highlight

  root.menuOpen = false;
  menuOffcanvasEl = document.getElementById('offcanvasNavbar');
  if (menuOffcanvasEl != null) {
    menuOffcanvas = new bootstrap.Offcanvas(menuOffcanvasEl);
    menuOffcanvasEl.addEventListener('show.bs.offcanvas', function(event) {
      root.menuOpen = !root.menuOpen;
      return root.$applyAsync();
    });
  }
  root.option = function(name) {
    var ref, ref1;
    if (((ref = $route.current) != null ? (ref1 = ref.$$route) != null ? ref1.options : void 0 : void 0) == null) {
      return null;
    }
    if ($route.current.$$route.options[name] == null) {
      return null;
    }
    return $route.current.$$route.options[name];
  };
  root.at = function(menu) {
    return root.menu === menu;
  };
  root.get = function(param) {
    return $routeParams[param];
  };
  
  // Update menu item

  logged_in_stat = false;
  root.$on('$routeChangeSuccess', function(event, next, current) {
    var currentLang, lang, ref, ref1;
    root.activeAction = true;
    root.menu = '';
    if (root.option('menu')) {
      root.menu = root.option('menu');
    }
    if (logged_in_stat) {
      root.$broadcast('sendCustomStat', null, 'logged_in', "Logged in");
      logged_in_stat = false;
    }
    // scroll top on route change
    $timeout(function() {
      return smoothScr.scroll('#body-top', 0);
    });
    lang = $translate.use() || $cookies.get('NG_TRANSLATE_LANG_KEY') || 'es';
    
    // Force ES language on /soon page (only if not already ES to avoid reload loop)
    if (((ref = $route.current) != null ? (ref1 = ref.$$route) != null ? ref1.originalPath : void 0 : void 0) === '/soon') {
      currentLang = $translate.use() || langKey || 'es';
      if (currentLang !== 'es') {
        $translate.use('es');
      }
    }
    return lang = $translate.use() || langKey || 'es';
  });
  root.$on('$translateChangeEnd', function() {
    var lang;
    if (!$translate.use()) {
      return;
    }
    lang = $translate.use() || $cookies.get('NG_TRANSLATE_LANG_KEY') || 'es';
    root.lang = lang === 'en' ? 'en' : lang;
    $route.reload();
    loadChat();
    if (root.at('home')) {
      return root.$broadcast('resetLangVideo');
    }
  });
  routeReload = false;
  root.$on('$routeChangeStart', function(event, next, current) {
    var availablePath, availablePath2, nextPath, protectedPath, protectedPath2, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    routeReload = false;
    if (!root.pageLoaded) {
      routeReload = true;
      return event.preventDefault();
    }
    if (menuOffcanvas != null) {
      menuOffcanvas.hide();
    }
    if (((current != null ? (ref = current.$$route) != null ? ref.controller : void 0 : void 0) === "ProgramsCtrl" || (next != null ? (ref1 = next.$$route) != null ? ref1.controller : void 0 : void 0) === "ProgramsCtrl") && ((ref2 = root.user) != null ? ref2.auth_ticket : void 0) && (current != null ? current.$$route : void 0) !== (next != null ? next.$$route : void 0)) {
      root.$broadcast('toggleFloatPlayer');
    }
    nextPath = (next != null ? (ref3 = next.$$route) != null ? ref3.originalPath : void 0 : void 0) || '/logout';
    protectedPath = []; //'/automation-solutions/:id'
    protectedPath2 = ['/automation-solutions'];
    availablePath = ['/soon']; // '/soon'
    availablePath2 = [];
    root.no_access = false;
    // if not in public pages
    if (indexOf.call(protectedPath, nextPath) >= 0) {
      if (!((ref4 = root.user) != null ? ref4.auth_ticket : void 0)) {
        event.preventDefault();
        if (current != null) {
          return event.preventDefault();
        } else {
          return $location.path('/soon'); // /soon
        }
      }
      
      // before event allow user only home page and soon event they have access
      if (moment().isBefore('2026-06-16 08:30:00')) {
        if (availablePath2.length > 0 && indexOf.call(availablePath2, nextPath) < 0) {
          event.preventDefault();
          return $location.path(availablePath[0]);
        }
      }
      if (((ref5 = root.user) != null ? ref5.role : void 0) === 'exhibitor') {
        if (((ref6 = next.params) != null ? ref6.id : void 0) == null) {
          UI.notify(false, 'Current access allowed only to view preview page');
          return root.logout();
        }
        if (((ref7 = root.session) != null ? (ref8 = ref7.user) != null ? ref8.id : void 0 : void 0) != null) {
          if (parseInt(next.params.id) !== root.session.user.id) {
            UI.notify(false, 'Current access allowed only to view preview page');
            return root.logout();
          }
        }
      }
    } else {
      if (!((ref9 = root.user) != null ? ref9.auth_ticket : void 0)) {
        if (root.settings.registration_link_test && indexOf.call(availablePath2, nextPath) < 0) {
          event.preventDefault();
          return $window.location = root.settings.registration_link;
        }
        
        // without access link always goes to welcome/soon page
        if (availablePath.length > 0 && indexOf.call(availablePath, nextPath) < 0) {
          event.preventDefault();
          return $location.path('/soon'); // /soon
        }
      }
      
      // before event allow user only home page and soon event they have access
      if (moment().isBefore('2024-06-16 08:30:00')) {
        if (((ref10 = (ref11 = root.session) != null ? ref11.user.id : void 0) === 1359513) || ((ref12 = root.user) != null ? ref12.role : void 0) === 'exhibitor' || (ref13 = (ref14 = root.session) != null ? ref14.user.email : void 0, indexOf.call([], ref13) >= 0)) {
          return root.no_access = false;
        } else {
          root.no_access = true;
          if (indexOf.call(protectedPath2, nextPath) >= 0) {
            event.preventDefault();
            return $location.path("/");
          }
        }
      } else {
        /*
        aP = if root.user?.auth_ticket then availablePath2 else availablePath
        if aP.length > 0 && nextPath not in aP
          event.preventDefault()
          return $location.path(aP[0])
        */
        root.no_access = false;
        if (((ref15 = root.user) != null ? ref15.role : void 0) === 'exhibitor') {
          if (((ref16 = next.params) != null ? ref16.id : void 0) == null) {
            UI.notify(false, 'Current access allowed only to view preview page');
            return root.logout();
          }
          if (((ref17 = root.session) != null ? (ref18 = ref17.user) != null ? ref18.id : void 0 : void 0) != null) {
            if (parseInt(next.params.id) !== root.session.user.id) {
              UI.notify(false, 'Current access allowed only to view preview page');
              return root.logout();
            }
          }
        }
      }
    }
  });
  
  // Load chat if ticket exist

  root.chatOpen = false;
  loadChat = function() {
    var ref;
    return false;
    if (root.xpo != null) {
      root.xpo.destroyChat();
    }
    if (!((ref = root.user) != null ? ref.auth_ticket : void 0)) {
      return;
    }
    root.xpo = new XPOSupport(root.user.auth_ticket, 451, root.lang, '#001034', '#00FFB9', null, "'Siemens'");
    root.xpo.onChatWindowOpened(function() {
      root.chatOpen = true;
      if (root.overlay) {
        root.overlay = false;
      }
      return root.$applyAsync();
    });
    root.xpo.onChatWindowClosed(function() {
      root.chatOpen = false;
      return root.$applyAsync();
    });
    return root.xpo.onChatPartnerClicked(function(args) {
      if ((args != null ? args.user_id : void 0) == null) {
        return;
      }
      $location.path(`/automation-solutions/${args.user_id}`);
      return root.$applyAsync();
    });
  };
  toFixedHex = function(num = null) {
    var hex;
    if (!num) {
      num = Math.random() * (1000 - 1) + 1;
      if (root.tuser != null) {
        num = root.tuser;
      }
    }
    if (typeof num !== 'bigint') {
      num = BigInt(num);
    }
    hex = num.toString(16).padStart(16, '0');
    if (hex.length > 16) {
      hex = hex.slice(-16);
    }
    return hex;
  };
  
  // Session data

  root.session = null;
  root.$on('proveSession', function(event, redirect = false, logout = false, autologin = false) {
    var locParams, locPath, newAuth, pseudoLogin, ref, ref1, ref2;
    root.user = $cookies.getObject('user') || null;
    root.tuser = $cookies.get('tuser') || null;
    if (logout) {
      $location.search('auth_ticket', null);
      $location.search('auth_token', null);
    } else {
      locPath = $location.path();
      locParams = $location.search();
      if (locParams.auth_ticket && String(locPath).indexOf('automation-solutions/') !== -1) {
        root.user = {
          auth_ticket: locParams.auth_ticket,
          role: 'exhibitor'
        };
        // preview mode ON but check if ticket is exhibitor after getting details
        root.preview = true;
      }
      pseudoLogin = false;
      // login via link
      if (locParams.auth_token || locParams.auth_ticket) {
        newAuth = locParams.auth_token || locParams.auth_ticket;
        redirect = true;
        if (!((ref = root.user) != null ? ref.auth_ticket : void 0) || (((ref1 = root.user) != null ? ref1.auth_ticket : void 0) !== newAuth)) {
          pseudoLogin = true;
        } else {
          //$location.search('auth_ticket', null)
          //$location.search('auth_token', null)
          console.debug("clear location auth");
        }
        root.user = {
          auth_ticket: locParams.auth_token || locParams.auth_ticket
        };
        root.preview = false;
      }
    }
    if (((ref2 = root.user) != null ? ref2.auth_ticket : void 0) == null) {
      if (routeReload) {
        $route.reload();
      }
      if (root.tuser == null) {
        root.tuser = Date.now();
        $cookies.put('tuser', root.tuser);
      }
      root.$broadcast('getFavorites');
      return root.pageLoaded = true;
    }
    return APICheckin.get({
      auth_ticket: root.user.auth_ticket,
      _private: true
    }, function(data) {
      if ((locParams != null ? locParams.auth_ticket : void 0) || (locParams != null ? locParams.auth_token : void 0)) {
        (new APIFavorites({
          auth_ticket: root.user.auth_ticket,
          shortcode: data.shortcode,
          role: data.role
        })).$save({
          shortcode: data.user.email,
          entrycode: 'reg',
          exhibitor_id: 111
        });
      }
      if (pseudoLogin || autologin) {
        logged_in_stat = true;
        pseudoLogin = false;
        $location.search('auth_ticket', null);
        $location.search('auth_token', null);
      } else {
        logged_in_stat = false;
      }
      root.session = data;
      if (!root.user.shortcode) {
        root.user.shortcode = data.shortcode;
      }
      root.user.role = data.role;
      if (data.shortcode_supplementary) {
        root.tuser = data.shortcode_supplementary;
        $cookies.put('tuser', root.tuser);
      }
      $cookies.putObject('user', root.user);
      root.preview = false;
      if (root.user.role === 'exhibitor') {
        root.preview = true;
        if (root.get('id')) {
          if (parseInt(root.get('id')) !== data.user.id) {
            return root.logout();
          }
        }
      }
      loadChat();
      root.pageLoaded = true;
      root.$broadcast('getFavorites');
      if (routeReload) {
        //root.$broadcast('displayTips')

        //root.$broadcast('showCountryModal') unless root.session.user.country
        return $route.reload();
      }
      if (redirect) {
        return $location.path('/');
      }
    }, function(response) {
      UI.notify(false, response.data.error);
      return root.logout();
    });
  });
  return root.logout = function(redirect = true) {
    root.$broadcast('sendCustomStat', null, 'logged_out', `Logged out from ${root.ngMeta.title || 'Home'} page`);
    root.$broadcast('closeAllTips');
    root.preview = false;
    root.user = null;
    root.session = null;
    $cookies.remove('user');
    $cookies.remove('s_e451_tips');
    root.$emit('proveSession', false, true);
    if (redirect) {
      $location.path('/logout');
    }
    return root.$applyAsync();
  };
})).config([
  '$routeProvider',
  '$locationProvider',
  'cfpLoadingBarProvider',
  '$qProvider',
  '$cookiesProvider',
  '$translateProvider',
  '$animateProvider',
  'ngMetaProvider',
  function(r,
  l,
  c,
  q,
  co,
  t,
  a,
  n) {
    var now;
    a.classNameFilter(/animate-/);
    now = new Date();
    co.defaults.expires = new Date(now.getFullYear(),
  now.getMonth(),
  now.getDate() + 100);
    n.useTitleSuffix(true);
    n.setDefaultTitle('Siemens Smart Day');
    n.setDefaultTitleSuffix(' | Siemens Smart Day');
    q.errorOnUnhandledRejections(false);
    l.html5Mode(true);
    l.hashPrefix('');
    c.includeSpinner = false;
    t.useStaticFilesLoader({
      prefix: 'assets/langs/locale-',
      suffix: '.json'
    });
    t.preferredLanguage('es');
    t.useCookieStorage();
    t.fallbackLanguage('es');
    r.when('/',
  {
      controller: 'HomeCtrl',
      templateUrl: moment().isBefore('2026-06-16 08:30:00') ? "html/home_before.html" : "html/home.html",
      options: {
        menu: 'home'
      },
      data: {
        meta: {
          title: 'Home',
          description: 'Home'
        }
      }
    });
    r.when('/automation-solutions',
  {
      controller: 'ExhibitorsListCtrl',
      templateUrl: "html/exhibitors/list.html",
      options: {
        menu: 'exhibitors'
      },
      data: {
        meta: {
          title: 'Automation Solutions',
          description: 'Automation Solutions'
        }
      }
    });
    r.when('/automation-solutions/:id',
  {
      controller: 'ExhibitorsViewCtrl',
      templateUrl: "html/exhibitors/detail.html",
      options: {
        menu: 'exhibitors'
      },
      data: {
        meta: {
          title: 'Automation Solutions',
          description: 'Automation Solutions'
        }
      },
      resolve: {
        data: [
          '$route',
          'ngMeta',
          'APIRead',
          '$rootScope',
          function($route,
          ngMeta,
          APIRead,
          root) {
            return APIRead.query({
              exhibitor: $route.current.params.id,
              entry_type: 'campaign,usecase',
              lang: root.lang || 'es'
            },
          function(data) {
              if (data.length > 0) {
                ngMeta.setTitle(data[0].title);
                return ngMeta.setTag('description',
          data[0].description || data[0].title);
              }
            });
          }
        ]
      }
    });
    r.when('/program',
  {
      controller: 'ProgramsCtrl',
      templateUrl: "html/programs.html",
      options: {
        menu: 'programs'
      },
      data: {
        meta: {
          title: 'Program',
          description: 'Program'
        }
      }
    });
    r.when('/speaker-experts',
  {
      controller: 'SpeakersCtrl',
      templateUrl: "html/speakers_it.html",
      options: {
        menu: 'speakers'
      },
      data: {
        meta: {
          title: 'Speaker & Experts',
          description: 'Speaker & Experts'
        }
      }
    });
    /*
    r.when '/video',
      controller: 'VideosListCtrl'
      templateUrl: "html/videos.html"
      options:
        menu: 'videos'
      data:
        meta:
          title: 'Videos'
          description: 'Videos'
    */
    r.when('/deepdivesessions',
  {
      controller: 'VideosListCtrl',
      templateUrl: "html/videos-deep.html",
      options: {
        menu: 'videos-deep'
      },
      data: {
        meta: {
          title: 'Deep Dive Sessions',
          description: 'Deep Dive Sessions'
        }
      }
    });
    r.when('/favorites',
  {
      controller: 'FavoritesListCtrl',
      templateUrl: "html/favorites.html",
      options: {
        menu: 'favs'
      },
      data: {
        meta: {
          title: 'Favorites',
          description: 'Favorites'
        }
      }
    });
    r.when('/soon',
  {
      controller: 'EmptyCtrl',
      templateUrl: "html/welcome.html",
      options: {
        menu: 'auth'
      },
      data: {
        meta: {
          title: 'Soon',
          description: 'Soon'
        }
      }
    });
    r.when('/registration',
  {
      controller: 'RegistrationCtrl',
      templateUrl: "html/auth/registration.html",
      options: {
        menu: 'auth'
      },
      data: {
        meta: {
          title: 'Registration',
          description: 'Registration'
        }
      }
    });
    r.when('/forgot-login',
  {
      controller: 'PasswordCtrl',
      templateUrl: "html/auth/forgot.html",
      options: {
        menu: 'auth'
      },
      data: {
        meta: {
          title: 'Forgot login',
          description: 'Forgot login'
        }
      }
    });
    r.when('/confirm',
  {
      controller: 'ConfirmCtrl',
      templateUrl: "html/auth/confirm.html",
      options: {
        menu: 'auth'
      },
      data: {
        meta: {
          title: 'Confirm registration',
          description: 'Confirm registration'
        }
      }
    });
    r.when('/docs',
  {
      controller: 'DocsCtrl',
      templateUrl: "html/docs.html",
      options: {
        menu: 'docs'
      },
      data: {
        meta: {
          title: 'Documentation & Offers',
          description: 'Documentation & Offers'
        }
      }
    });
    /*
    */
    r.when('/auth',
  {
      controller: 'AuthCtrl',
      templateUrl: "html/auth/empty.html",
      options: {
        menu: 'auth'
      },
      data: {
        meta: {
          title: 'Auth',
          description: 'Auth'
        }
      }
    });
    return r.otherwise({
      redirectTo: '/automation-solutions'
    });
  }
]);
